import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import MultiLines from './MultiLines';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import {Tools} from './Tools';
import {Inc,KbinColabo} from './Inc';
import useStyles from './Styles';
import {Theme} from './Theme';

interface Props {
	isOpen:boolean,
    values:KbinColabo,
    send():void,
    close(): void,
}

const KbinConfirm: React.FC<Props> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
	if(!props.isOpen){
		return (null);
	}
	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color='primary'>Ｋ便鉄道コラボのご相談窓口</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					この内容でよろしいですか？<br/>
					よろしかったら「送信する」を押して下さい。<br/>
				</div>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>コラボ内容の説明</FormLabel>
							<div className={classes.formValue} style={{marginTop:'0.5em'}}>
								<MultiLines text={props.values.memo} name="text"/>
							</div>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>イベント名</FormLabel>
							<div className={classes.formValue} style={{marginTop:'0.5em'}}>
								{props.values.title!=='' ? (
								<MultiLines text={props.values.title} name="title"/>
								):(
								<span style={{color:'#666666'}}>なし</span>
								)}
							</div>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>開催時期</FormLabel>
							<div className={classes.formValue} style={{marginTop:'0.5em'}}>
								{props.values.jiki!=='' ? (
								<MultiLines text={props.values.jiki} name="text"/>
								):(
								<span style={{color:'#666666'}}>まだわからない</span>
								)}
							</div>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>参加作家さん</FormLabel>
							<div className={classes.formValue} style={{marginTop:'0.5em'}}>
								{props.values.artists!=='' ? (
								<MultiLines text={props.values.artists} name="text"/>
								):(
								<span style={{color:'#666666'}}>まだわからない</span>
								)}
							</div>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>対象作品</FormLabel>
							<div className={classes.formValue} style={{marginTop:'0.5em'}}>
								{Tools.getLabel(Inc.kbincolabotargets,props.values.target)}
							</div>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12}>
						<FormControl className={classes.formControl} fullWidth={true}>
							<FormLabel component="label" className={classes.formLabel}>バナーの作成</FormLabel>
							<div className={classes.formValue} style={{marginTop:'0.5em'}}>
								{Tools.getLabel(Inc.kbincolabobanners,props.values.banner)}
							</div>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='送信する' onClick1={props.send} button2="やりなおし" onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default KbinConfirm;
